import {useIntl} from 'react-intl'
import {PlantWithProjectName} from '../../entities/plant'
import {
  DatabasePlantRecord,
  instance as plantsService,
  prepareOverwrittenBaseFields,
} from '../../services/PlantsService'

function preparePhotos(
  plantName: string,
  databasePlant: Partial<DatabasePlantRecord['fields']>,
  fieldName: keyof DatabasePlantRecord['fields'],
  tag?: string
) {
  const photos = databasePlant[fieldName]

  if (!Array.isArray(photos)) {
    return []
  }

  return photos.map((photo, index) => ({
    uid: index + tag,
    name: `${plantName}-${tag}-${index}`,
    status: 'done',
    url: photo.url,
    photoType: fieldName,
  }))
}

export async function prepareFormFields(
  plant?: PlantWithProjectName,
  databasePlantFields?: Partial<DatabasePlantRecord['fields']>
) {
  const databasePlant = prepareOverwrittenBaseFields(
    {},
    databasePlantFields,
    {language: 'ru'}, // TODO
    true
  )
  const plantName = databasePlant['Общераспространенное название']

  const basePlantPhotos = preparePhotos(plantName, databasePlant || {}, 'Фотографии растения')
  const basePlantFlowersPhotos = preparePhotos(
    plantName,
    databasePlant || {},
    'Фотографии цветов',
    'f'
  )
  const basePlantLeavesPhotos = preparePhotos(
    plantName,
    databasePlant || {},
    'Фотографии листьев',
    'l'
  )
  const basePlantFruitsPhotos = preparePhotos(
    plantName,
    databasePlant || {},
    'Фотографии плодов',
    'fr'
  )

  const signedPhotoURLs = await plantsService.getPlantImageURLs(plant?.photos)
  const userPlantPhotos = plant?.photos.map((photoName, index) => ({
    uid: index,
    photoName: photoName,
    name: plant.name + index,
    status: 'done',
    url: signedPhotoURLs.urls[index],
    photoType: 'Мои фотографии',
  }))

  // только поля, зависящие от базового растения: собственные поля растения (название,
  // проект, участок, комментарий, дата посадки) не должны перезаписывать правки в форме
  const fieldValues = {
    ...(databasePlant || {}),
    ...plant?.overwrittenBaseFields,
    files: [
      ...basePlantPhotos,
      ...(basePlantFlowersPhotos || []),
      ...(basePlantLeavesPhotos || []),
      ...(basePlantFruitsPhotos || []),
      ...(userPlantPhotos || []),
    ],
  }

  return fieldValues
}
